"use client";

import { SidebarItem } from "@/components/layout/sidebar/sidebar-layout";
import { AttentionBadge } from "@/features/conversations/components/shared/attention-badge";
import { useAttentionCounts } from "@/features/conversations/hooks/use-attention-counts";
import { useConversationsFeature } from "@/features/conversations/hooks/use-conversations-feature";
import { COPY } from "@/features/conversations/lib/copy";
import { CONVERSATIONS_ROUTES } from "@/features/conversations/lib/routes";

export function SidebarConversationsItem({
  expanded,
  projectId,
  active,
}: {
  expanded: boolean;
  projectId: string | null;
  active?: boolean;
}) {
  const enabled = useConversationsFeature();
  const { total } = useAttentionCounts(
    enabled && projectId ? { project_id: projectId } : null,
  );
  if (!enabled) return null;
  return (
    <SidebarItem
      href={CONVERSATIONS_ROUTES.area}
      icon="IconVideo"
      label={COPY.area}
      expanded={expanded}
      active={active}
      disabled={!projectId}
      disabledReason="Select a project to access Meetings"
      trailing={<AttentionBadge count={total} />}
    />
  );
}
